import { createBrowserRouter, Navigate } from "react-router-dom";
import { RootLayout } from "./RootLayout";
import OnboardingLayout from "./OnboardingLayout";
import AuthenticatedLayout from "./AuthenticatedLayout";
import { routes } from "./routesConfig";
import { PageRoutes } from "../constants/historyGaming";

export const router = createBrowserRouter([
  {
    element: <RootLayout />,
    children: [
      {
        element: <OnboardingLayout />,
        children: [
          {
            element: <AuthenticatedLayout />,
            children: [
              ...routes,
              {
                path: "*",
                element: <Navigate to={PageRoutes.HomePage} replace />,
              },
            ],
          },
        ],
      },
    ],
  },
]);
